const datepickerCss = new CSSStyleSheet();
datepickerCss.insertRule(`
  .mdpc-footer {
      flex-direction: row-reverse;
      justify-content: flex-start !important;
    }
  `);

/**
 * Provides custom styles for fw-datepicker element.
 * @param element Element to provide styles for.
 */
export function provideDatepickerStyles(element: HTMLElement): void {
    const root = element.shadowRoot;

    if (root !== null && !root.adoptedStyleSheets.includes(datepickerCss)) {
        root.adoptedStyleSheets.push(datepickerCss);
    }
}
